// Used as a communications object between UI components
// Corresponds to a request by a component to display the source HML for a given UUID
export class SubmissionSourceModalRequest {
    constructor(public uuid: string,
                public hmlId: string,
                public uploaderFileName: string,
                public submissionStatus: string) {
    }
}
